import { getCountryCodeFromDomain } from '@utils/countries';

export const AUTHORIZED_TIMEOUT = 60000;
export const DEFAULT_COUNTRY_CODE = getCountryCodeFromDomain().toUpperCase();
export const DEFAULT_PHONE_PREFIX = '+32';
